<div class="container-fluid">

    <div class="row  justify-content-center align-items-center" style='height: 100%;'>
        <img [src]='data.imgPath' />
    </div>
</div>